/**
 * DOM-based Routing
 *
 * Based on {@link http://goo.gl/EUTi53|Markup-based Unobtrusive Comprehensive DOM-ready Execution} by Paul Irish
 *
 * The routing fires all common scripts, followed by the page specific scripts.
 * Add additional events for more control over timing e.g. a finalize event
 */
const Router = function (routes) {
    /**
    * Create a new Router
    * @param {Object} routes
    */
    this.routes = routes;
    /**
    * Fire Router events
    * @param {string} route DOM-based route derived from body classes (`<body class="...">`)
    * @param {string} [event] Events on the route. By default, `init` and `finalize` events are called.
    * @param {string} [arg] Any custom argument to be passed to the event.
    */
    this.fire = function (route, event = "init", arg) {
        document.dispatchEvent(new CustomEvent("routed", {
            bubbles: true,
            detail: {
                route,
                fn: event,
            },
        }));
        if (route === "") {
            return;
        }
        if (!(route in this.routes)) {
            return;
        }
        if (!(event in this.routes[route]) && typeof this.routes[route][event] !== "function") {
            return;
        }
        this.routes[route][event](arg);
    };
    /**
    * Automatically load and fire Router events
    *
    * Events are fired in the following order:
    *  * common init
    *  * page-specific init
    *  * page-specific finalize
    *  * common finalize
    */
    this.loadEvents = function () {
        this.fire("main");
        document.body.className.split(/\s+/).forEach((className) => {
            this.fire(className);
            this.fire(className, "finalize");
        });
        this.fire("main", "finalize");
    };
};

export default Router;
